import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import emailOutline from '@iconify/icons-eva/email-outline';
import phoneOutline from '@iconify/icons-eva/phone-outline';
import homeOutline from '@iconify/icons-eva/home-outline';
import { ContactForm } from '../components/_dashboard/user';
import { aboutData, ourTeamData } from '../DATA/DataText';

const useStyles = makeStyles((theme) => ({
  backgroundFix: {
    minHeight: '200px',
    width: '100%',
    marginTop: 80,
    background: '#f27474',
    zIndex: 2,
    position: 'relative'
  },
  centerTitleContainer: {
    width: '100%',
    minHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '50px 100px',
    '& h1': {
      fontSize: '40px',
      color: 'white',
      fontWeight: 500,
      lineHeight: '28px',
      fontFamily: 'Open Sans, sans-serif',
      textAlign: 'center',
      '@media (max-width:780px)': {
        fontSize: '30px'
      }
    },
    '& h3': {
      fontSize: '17px',
      letterSpacing: '1px',
      lineHeight: '28px',
      fontWeight: 400,
      color: 'white',
      marginTop: 25,
      textAlign: 'center',
      fontFamily: 'Reem Kufi, sans-serif',
      '@media (max-width:780px)': {
        fontSize: '17px'
      }
    },
    '@media (max-width:780px)': {
      padding: '50px 20px'
    }
  },
  centerTitle: {
    width: 400,
    height: 150,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    marginTop: '10px',
    padding: '0px 10px',
    '& h1': {
      fontSize: '40px',
      color: 'white',
      fontWeight: 500,
      lineHeight: '28px',
      letterSpacing: '1px',
      fontFamily: 'Reem Kufi, sans-serif',
      textAlign: 'center'
    },
    '& h3': {
      fontSize: '20px',
      fontWeight: 500,
      color: 'white',
      marginTop: 15
    }
  },
  wraper: {
    // backgroundColor: 'red',
    display: 'flex',
    justifyContent: 'center',
    padding: '50px 0px'
  },
  contact: {
    // backgroundColor: 'lightgrey',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 50
  },
  gridItem: {
    // backgroundColor: 'red',
    '@media (max-width:900px)': {
      marginBottom: 15,
      marginTop: 15,
      display: 'flex',
      justifyContent: 'center'
    }
  },
  contactInfo: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    marginTop: 30,
    '&:hover': {
      '& $description, $iconCard': {
        color: '#F78181'
      }
    }
  },
  title: {
    fontSize: '30px',
    fontFamily: 'Oregano, cursive',
    color: '#4c494a',
    fontWeight: 400
  },
  description: {
    fontSize: '18px',
    fontFamily: 'Oregano, cursive',
    color: 'grey'
  },
  iconCard: {
    fontSize: '18px',
    marginRight: 15,
    fontFamily: 'Oregano, cursive',
    color: 'grey'
  },
  cardIllustration: {
    height: '100%',
    width: '100%',
    backgroundColor: 'white'
  },
  imgIllustration: {
    height: 'auto',
    width: '100%'
  },
  butterflyContainer: {
    height: 100,
    width: 120,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
    '& h3': {
      zIndex: 2,
      fontSize: '15px',
      fontWeight: 500,
      color: 'white',
      fontFamily: 'Oregano, cursive'
    }
  },
  butterflyImg: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    zIndex: 1
  },
  buttonShowmore: {
    color: '#F78181',
    position: 'relative',
    cursor: 'pointer',
    width: 65,
    marginTop: 20,
    transform: 'rotate(-7deg)',
    fontFamily: 'Oregano, cursive',
    '& a': {
      color: '#F78181',
      cursor: 'pointer',
      textDecoration: 'none'
    },
    '&:after': {
      position: 'absolute',
      content: '""',
      display: 'block',
      left: 0,
      top: 25,
      bottom: 0,
      width: '100%',
      height: '1px',
      background: '#F78181'
    },
    '&:hover': {
      animation: '$all 1s forwards'
    }
  },
  textIllustration: {
    fontSize: '15px',
    fontWeight: 400,
    color: '#555',
    marginTop: 10,
    textAlign: 'left',
    lineHeight: '24pt',
    fontFamily: 'Open Sans, sans-serif'
  },
  TitleSection1: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '40px',
    fontWeight: 500,
    color: '#F78181',
    margin: '50px 0px',
    textAlign: 'left',
    position: 'relative',
    '&::after': {
      position: 'absolute',
      content: '""',
      left: '0px',
      bottom: '-10px',
      width: '30%',
      height: '3px',
      background: '#F78181'
    },
    '@media (max-width:1024px)': {
      fontSize: '35px'
    }
  },
  TitleSection: {
    fontFamily: 'Reem Kufi, sans-serif',
    fontSize: '40px',
    fontWeight: 500,
    color: '#F78181',
    margin: '50px 0px',
    textAlign: 'center',
    position: 'relative',
    '&::after': {
      position: 'absolute',
      content: '""',
      left: '0px',
      right: '0px',
      margin: '0px auto',
      bottom: '-10px',
      width: '5%',
      height: '3px',
      background: '#F78181'
    },
    '@media (max-width:1024px)': {
      fontSize: '35px'
    }
  },
  cardContainer: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '50px',
    '@media (max-width:900px)': {
      marginBottom: 15,
      marginTop: 15
    }
  },
  card: {
    height: '100%',
    padding: '20px',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '5px',
    transition: 'all 0.1s ease-in',
    '&:hover': {
      boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)'
    }
  },
  titleCard: {
    fontSize: '17px',
    fontWeight: 600,
    color: '#F78181',
    marginTop: 10,
    textAlign: 'center',
    fontFamily: 'Reem Kufi, sans-serif',
    textTransform: 'capitalize'
  },
  descriptionCard: {
    fontSize: '15px',
    fontWeight: 400,
    color: 'grey',
    marginTop: 5,
    textAlign: 'center',
    fontFamily: 'Open Sans, sans-serif',
    textTransform: 'capitalize'
  },
  descriptionCard1: {
    textTransform: 'capitalize',
    fontSize: '15px',
    fontWeight: 400,
    color: '#949494',
    marginTop: 5,
    textAlign: 'center',
    fontFamily: 'Reem Kufi, sans-serif'
  },
  imgTeam: {
    height: '250px',
    width: '250px',
    objectFit: 'cover'
  }
}));

const About = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  return (
    <div>
      <Grid container xs={12} className={classes.backgroundFix}>
        <Box className={classes.centerTitleContainer}>
          <h1>{t('qui_sommes_nous')}</h1>
        </Box>
      </Grid>
      <Grid container xs={12} className={classes.wraper}>
        <Container style={{ overflow: 'hidden' }}>
          {aboutData.map((row) => (
            <Grid container xs={12} className={classes.contact}>
              <Grid
                item
                xs={12}
                md={6}
                className={classes.gridItem}
                style={{ paddingLeft: 50 }}
                order={row.id % 2 === 0 ? { xs: 1, md: 1 } : { xs: 1, md: 2 }}
              >
                <Box>
                  <Typography
                    className={classes.TitleSection1}
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    {t(row.title)}
                  </Typography>
                  <Typography
                    className={classes.textIllustration}
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    {t(row.text)}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                className={classes.gridItem}
                order={row.id % 2 === 0 ? { xs: 2, md: 2 } : { xs: 2, md: 1 }}
              >
                <Box className={classes.cardIllustration}>
                  <img
                    alt="img"
                    src={row.imgUrl}
                    className={classes.imgIllustration}
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  />
                </Box>
              </Grid>
            </Grid>
          ))}
          <h1 className={classes.TitleSection} style={{ textAlign: 'center' }}>
            {t('notre_équipe')}
          </h1>
          <Grid container className={classes.cardContainer}>
            {ourTeamData.map((row) => (
              <Grid item xs={12} sm={4} className={classes.cardContainer}>
                <Box
                  className={classes.card}
                  style={{ boxShadow: '0 10px 25px 0 rgb(1 45 126 / 15%)' }}
                >
                  <img alt="img" src={row.imgUrl} className={classes.imgTeam} />
                  <Typography className={classes.titleCard}>{row.title}</Typography>
                  <Typography className={classes.descriptionCard}>{row.description}</Typography>
                  <Typography className={classes.descriptionCard1}>{row.description1}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Grid>
    </div>
  );
};

export default About;
